import { render, staticRenderFns } from "./UnPublic.vue?vue&type=template&id=ca83b0c8&scoped=true"
import script from "./UnPublic.vue?vue&type=script&lang=js"
export * from "./UnPublic.vue?vue&type=script&lang=js"
import style0 from "./UnPublic.vue?vue&type=style&index=0&id=ca83b0c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca83b0c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca83b0c8')) {
      api.createRecord('ca83b0c8', component.options)
    } else {
      api.reload('ca83b0c8', component.options)
    }
    module.hot.accept("./UnPublic.vue?vue&type=template&id=ca83b0c8&scoped=true", function () {
      api.rerender('ca83b0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UnPublic.vue"
export default component.exports